import { koComponent } from '../../ko-utils';
import $api from '../../api';
import { getLocalSettingsOrDefault } from '../../utils/localSettings';

class IntroWizardView {
    constructor(params, initParams) {
        this.page = initParams;

        this.historyCleaners = {
            0: () => { this.installationType(null); clearInterval(this.interval); },
            1: () => { this.techType(null); clearInterval(this.interval); },
            2: () => { clearInterval(this.interval); }
        }

        this.isVisible = ko.observable(false);
        this.wizardStep = ko.observable(0);
        this.wizardStep.subscribe((val) => {
            if (val == 3) {
                this.startInstallChecker();
            }
        });

        this.installationType = ko.observable(localStorage.getItem(lsKey('installtype'))); // standard|browser
        this.installationType.subscribe((val) => {
            if (val == 'standard') {
                this.wizardSetStep(1, 'standard-type');
            } else if (val == 'browser') {
                this.wizardSetStep(1, 'browser');
            }

            localStorage.setItem(lsKey('installtype'), val);

            TRACK_EVENT('Projects', 'Setup Wizard - Install type selected', { type: val });
        });

        this.techType = ko.observable(localStorage.getItem(lsKey('techtype')));
        this.techType.subscribe((val) => {
            switch (val) {
                case 'react': this.wizardSetStep(2, 'react'); break;
                case 'vue': this.wizardSetStep(2, 'other-web'); break;
                case 'angular': this.wizardSetStep(2, 'other-web'); break;
                case 'npm': this.wizardSetStep(2, 'other-web'); break;
                case 'web': this.wizardSetStep(2, 'web'); break;
            }

            localStorage.setItem(lsKey('techtype'), val);

            TRACK_EVENT('Projects', 'Setup Wizard - Stack type selected', { type: val });
        });

        this.devMails = ko.observable('');
        this.devMails.isEmpty = ko.pureComputed(() => {
            return this.devMails() === '' || !this.devMails();
        });

        this.createDemoData = ko.observable(true);

        this.wizardHistory = [];

        TRACK_EVENT('Projects', 'Setup Wizard Loaded');
    }

    startInstallChecker() {
        this.interval = setInterval(() => {
            checkReady();
        }, 3000);
        checkReady();

        function checkReady() {
            $api.projects.checkIfInstalled(
                { projectCode: auth.project.UniqueCode },
                {},
                (res) => {
                    if (res && res.installed) {
                        TRACK_EVENT('Projects', 'Setup Wizard - DONE');

                        setTimeout(() => { // just to be sure the tracking event has a chance to finish
                            window.location.reload();
                        }, 500);
                    }
                }
            );
        }
    }

    koDescendantsComplete() {
        const savedSteps = {
            step: localStorage.getItem(lsKey('step')) || 0,
            stepId: localStorage.getItem(lsKey('stepid')) || null,
            stepsHistory: getLocalSettingsOrDefault(lsKey('steps_history'), [])
        };

        if (savedSteps.step != 0) {
            this.wizardSetStep(savedSteps.step, savedSteps.stepId, true);
        }

        this.wizardHistory = savedSteps.stepsHistory;

        setTimeout(() => {
            this.isVisible(true);
        }, 200);
    }

    codeReady() {
        this.wizardSetStep(3, 'awaiting');

        TRACK_EVENT('Projects', 'Setup Wizard - Code Ready');
    }

    extensionReady() {
        this.wizardSetStep(3, 'awaiting');

        TRACK_EVENT('Projects', 'Setup Wizard - Extension Ready');
    }

    sendCodeSnippet() {
        if (this.devMails.isEmpty()) return;

        TRACK_EVENT('Projects', 'Sending code snippet info to emails', { from: 'welcome_dashboard' });

        this.page.startSubmitting('devMails');
        $api.projects.sendCodeSnippetInfo(
            { projectCode: auth.project.UniqueCode },
            { targetEmails: this.devMails() },
            (resp) => {
                this.devMails('');
                this.page.stopSubmitting('devMails');
                this.page.showToast('Install instructions sent!');
            }
        );
    }

    wizardSetStep(step, stepId = null, { skipAnimation = false, isHistoryCall = false } = {}) {
        if (!isHistoryCall) {
            this.wizardHistory.push({ step: this.wizardStep(), stepId: this.wizardStepId });
            localStorage.setItem(lsKey('steps_history'), JSON.stringify(this.wizardHistory));
        }

        this.wizardStep(step);
        this.wizardStepId = stepId;

        localStorage.setItem(lsKey('step'), step);
        localStorage.setItem(lsKey('stepid'), stepId);

        console.log('setting', isHistoryCall, step, this.wizardHistory);
        isHistoryCall && this.historyCleaners[step] && this.historyCleaners[step]();

        setTimeout(() => {
            const el = document.getElementById('ws-' + (stepId != null ? stepId : this.wizardStep()));

            el && el.scrollIntoView({
                behavior: skipAnimation === true ? "auto" : "smooth",
            });
        }, 100);
    }

    goUp() {
        const prevItem = this.wizardHistory.pop();

        this.wizardSetStep(prevItem.step, prevItem.stepId, { skipAnimation: true, isHistoryCall: true });
    }

    closeWizard() {
        window.location.href = '/';
    }

    generateSampleData(callback) {
        $api.projects.generateSampleData(
            { projectCode: auth.project.UniqueCode },
            {},
            () => {
                callback();
            }
        )
    }

    loadExtension(extensionLoaderCallback, mode) {
        this.page.startSubmitting('connecting');

        const doWork = () => {
            extensionLoaderCallback();

            this.extensionReady();

            this.page.stopSubmitting('connecting');
        };

        if (/*this.createDemoData()*/mode === 'demo') {
            this.generateSampleData(doWork);
            TRACK_EVENT('Projects', 'Sample data created');
        } else {
            doWork();
            TRACK_EVENT('Projects', 'From scratch clicked');
        }
    }
}

function lsKey(name) {
    return `pf_install_wizard_${name}_${auth.project.UniqueCode}`;
}

window._clearPfWizard = function () {
    localStorage.removeItem(lsKey('step'));
    localStorage.removeItem(lsKey('stepid'));
    localStorage.removeItem(lsKey('techtype'));
    localStorage.removeItem(lsKey('installtype'));
    localStorage.removeItem(lsKey('steps_history'));
}

export default koComponent('intro-wizard-view', IntroWizardView);